import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";
import VariantInfo from "HSNDIR/VariantInfo.js";

import "LIBS/jquery.showhtml.js";


HSN.EditOptionsOffCanvas = (function (parent) {
    __extends(EditOptionsOffCanvas, parent);

    function EditOptionsOffCanvas() {
        var offCanvas = EditOptionsOffCanvas.__super__.constructor.call(this, {
            className : 'edit-options-off-canvas',
            sourceDirection : HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage : true
        });
        this._scope = this;
        this.name = 'HSN.EditOptionsOffCanvas';
        this.commerceService = HSN.Instance()._getCommerceService();
        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Edit Options', 'EditOptionsOffCanvas', 'Edit Options Off Canvas');

        this._variants = null;
        this._variantInfo = null;

        return offCanvas;
    }

    function eventHandlers(offCanvas) {
       $(offCanvas.Content).on('click', '#update-bag', function () {
            var variantResponse = GetVariantId('.product-options', 0, offCanvas);
            if (variantResponse.errorList) {
                return false;
            }
            var bagIdentity = offCanvas.Content.find('.edit-options-container').data('bag-id');
            var bagItemIdentity = offCanvas.Content.find('.edit-options-container').data('bag-item-id');
            HSN.SetWait();
            offCanvas.commerceService.UpdateVariant({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity, webId: variantResponse.value}, {
                callback : function(data) {
                    if(!data.success) {
                        HSN.RemoveWait();
                        alert('There was a problem editing your bag item. Please try again later.');
                    }
                    else {
                        offCanvas.Hide();
                        window.location.reload(true);
                    }
                },
                scope: offCanvas
            });
        });
    }

    EditOptionsOffCanvas.prototype.BindWidgets = function (offCanvas) {
        var variantJsonString = $('#json-variants', offCanvas.Content.find('.product-option-selector')).html();
        this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;
        this._variantInfo = new VariantInfo(this._variants);

        var productOptionSelector = new HSN.ProductOptionSelector({
            application: HSN.Instance(),
            container: offCanvas.Content.find('.product-option-selector'),
            imageContainer: $('.product-image', offCanvas.Content),
            preSelectedWebId: $('.pre_selected_webid', offCanvas.Content).val(),
            useSimpleMainImage: $('.is_edit_bag_preview', offCanvas.Content).val(),
            variantInfo: this._variantInfo
        }).init();
    }

    function GetVariantId(productCardScope, objectId, scope) {
        if (scope._variants !== null && scope._variants.length > 0) {
            var allErrors = [];
            var inputLabels = $('label.required-selection', productCardScope);
            var arr = [];

            $('.errors-pd').remove();

            $.each(inputLabels, function() {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', productCardScope);
                
                if(checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if(labelText.length) {
                        allErrors.push('Please select a ' + labelText);
                        inputLabel.addClass('inline-error');
                    }
                }
                else if(checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });

            //Item Sold out
            var variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                allErrors.push('Selection Not Available');
            }
            if (variant && variant.Callout && variant.Callout.Name === 'SoldOut') {
                allErrors.push('Item Sold Out');
            }

            var allErrorsLength = allErrors.length;
            if(allErrorsLength > 0) {
                var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

                for(var i = 0; i < allErrorsLength; i++) {
                    if(allErrors[i] !== null) {
                        $errors.find('ul').append('<li>' + allErrors[i] + '</li>');
                    }
                }

                var button = $('#update-bag');
                button.after($errors);
                var errorLeft = button.position().left + ((button.outerWidth() - $errors.outerWidth()) / 2);
                var errorTop = button.position().top + parseInt('-' + ($errors.height() + 2));
                $errors.css({
                    "top" : errorTop,
                    "left" : errorLeft
                });

                $errors.focus();
                $('.product-modal-option-status', productCardScope).last().text('');

                return { value : objectId, errorList : allErrors };
            }

            $.each(scope._variants, function(k, v) {
                if($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value : objectId };
    };

    EditOptionsOffCanvas.prototype._show = function (bagIdentity, bagItemIdentity) {
        $.ajax('/checkout/bag-actions/edit-options?bagIdentity=' + bagIdentity + '&bagItemIdentity=' + bagItemIdentity, {
            context: this,
            cache: false,
            dataType: 'html',
            data: { },
            success: function (data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function () {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return EditOptionsOffCanvas;
})(HSN.OffCanvas);



// WEBPACK FOOTER //
// ./assets/js/HSN/OffCanvas/Checkout/EditOptionsOffCanvas.js